import { useSystemHealth } from '../../../api/super-admin.api';

export function SystemPage() {
  const { data, isLoading } = useSystemHealth();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-4)' }}>
      <section style={{
        backgroundColor: 'var(--card-bg)',
        border: '1px solid var(--card-border)',
        borderRadius: 'var(--card-radius)',
        boxShadow: 'var(--card-shadow)',
        overflow: 'hidden',
      }}>
        <header style={{ padding: 'var(--space-4) var(--space-5)', borderBottom: '1px solid var(--color-border-default)' }}>
          <h2 style={{ margin: 0, fontFamily: 'var(--font-sans)', fontSize: 'var(--text-xl)', fontWeight: 'var(--font-weight-bold)', color: 'var(--color-text-brand)' }}>
            System-wide health
          </h2>
          <p style={{ marginTop: '2px', fontFamily: 'var(--font-sans)', fontSize: 'var(--text-sm)', color: 'var(--color-text-muted)' }}>
            Live aggregates across all organisations in Engage.
          </p>
        </header>

        {isLoading && <div style={{ padding: 'var(--space-4)' }}>Loading…</div>}

        {data && (
          <div style={{ padding: 'var(--space-5)', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 'var(--space-4)' }}>
            <Stat label="Organisations" value={data.organisations} />
            <Stat label="Users" value={data.users} />
            <Stat label="Campaigns" value={data.campaigns} />
            <Stat label="Active mailboxes" value={data.active_mailboxes} />
            <Stat label="Sends today" value={data.sends_today} />
          </div>
        )}
      </section>

      <section style={{
        padding: 'var(--space-4) var(--space-5)',
        border: '1px dashed var(--color-border-strong)',
        borderRadius: 'var(--card-radius)',
        backgroundColor: 'var(--color-surface-muted)',
      }}>
        <p style={{ margin: 0, fontFamily: 'var(--font-sans)', fontSize: 'var(--text-sm)', color: 'var(--color-text-muted)' }}>
          <strong>Coming next:</strong> per-org 30-day usage trends (requires the <code>usage_snapshots</code> table + daily cron from Section 13B.4),
          system-wide send limits, Postmark account status, sync-health surface.
        </p>
      </section>
    </div>
  );
}

function Stat({ label, value }: { label: string; value: number }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-1)', padding: 'var(--space-3) var(--space-4)', border: '1px solid var(--color-border-default)', borderRadius: 'var(--radius-input)' }}>
      <span style={{ fontFamily: 'var(--font-sans)', fontSize: 'var(--text-xs)', textTransform: 'uppercase', letterSpacing: 'var(--tracking-caps)', color: 'var(--color-text-muted)', fontWeight: 'var(--font-weight-semibold)' }}>{label}</span>
      <span style={{ fontFamily: 'var(--font-sans)', fontSize: 'var(--text-2xl)', fontWeight: 'var(--font-weight-bold)', color: 'var(--color-text-primary)' }}>{value.toLocaleString()}</span>
    </div>
  );
}
